import React from 'react';
import styled from 'styled-components';
import { Edit2, Book } from 'react-feather';
import FlexContainer from '../../../components/common/FlexContainer';


export default function RolSelection({ handleToggleRadio, register, error}) {
  return (
    <FlexContainer >
      <Title>¿Que tipo de usuario eres?</Title>
      <Wrapper>
        <Input
          type="radio" name="rol" id="Estudiante"
          value="estudiante"
          {...register("rol", { required: "Por favor selecciona tu rol" })}
          onChange={handleToggleRadio}
        />
        <Label htmlFor="Estudiante">
          <Edit2 />
          <span>Estudiante</span>
        </Label>
        <Input
          type="radio" name="rol" id="Docente"
          value="docente"
          {...register("rol", { required: "Por favor selecciona tu rol" })}
          onChange={handleToggleRadio}
        />
        <Label htmlFor="Docente">
          <Book />
          <span>Docente</span>
        </Label>
      </Wrapper>
      <Error>{error?.message}</Error>
    </FlexContainer>
  )
}

const Title = styled.span`
    margin: 16px 0;
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 90%;
    justify-content: center;
`;

const Input = styled.input`
    display: none;
    &:checked+label {
    background-color: var(--color-rosa);
    color: var(--color-blanco);
    }
`;

const Label = styled.label`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    margin: 16px;
    width: 100%;
    cursor: pointer;
    background-color: var(--color-blanco);
    border: 2px solid var(--color-rosa);
    border-radius: 10px;
    transition: all 0.3s;

    svg{
      margin-bottom: 8px;
    }
`;

const Error = styled.span`
    font-size: .8em;
    color: var(--color-error);
    margin-left: 24px;
`;




